'use client';

import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

import { env } from '~/env.mjs';

export const DatadogInit = () => {
  useEffect(() => {
    const isHeadless =
      window.navigator.userAgent.toLowerCase().includes('headless') ||
      window.navigator.userAgent.startsWith('Pingdom');
    const isDatadogInitialized =
      typeof datadogRum.getInternalContext() !== 'undefined';

    if (
      !isHeadless &&
      !isDatadogInitialized &&
      env.NEXT_PUBLIC_DATADOG_APPLICATION_ID &&
      env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN &&
      env.NEXT_PUBLIC_DATADOG_SITE &&
      env.NEXT_PUBLIC_DATADOG_SERVICE &&
      env.NEXT_PUBLIC_DATADOG_ENV
    ) {
      datadogRum.init({
        applicationId: env.NEXT_PUBLIC_DATADOG_APPLICATION_ID,
        clientToken: env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        site: env.NEXT_PUBLIC_DATADOG_SITE,
        service: env.NEXT_PUBLIC_DATADOG_SERVICE,
        env: env.NEXT_PUBLIC_DATADOG_ENV,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 100,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask',
        allowedTracingUrls: ['https://api-production.avodahmed.com/'],
      });

      datadogLogs.init({
        clientToken: env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN,
        site: env.NEXT_PUBLIC_DATADOG_SITE,
        env: env.NEXT_PUBLIC_DATADOG_ENV,
        version: env.NEXT_PUBLIC_APP_VERSION,
        forwardConsoleLogs: 'all',
        forwardErrorsToLogs: true,
        sessionSampleRate: 100,
        service: 'nsight-web',
      });
    }
  }, []);

  return null;
};
